import React, { useState, useEffect,useRef } from 'react';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import {
    MoreVertical, UploadCloud, FileText, X,
    ShieldCheck, FolderOpen, LayoutGrid, ArrowRight,
    CheckCircle2, AlertCircle, Clock, CircleDashed, Check, FileBadge,
    Edit3, Copy, Archive, Trash2, ChevronLeft, ArrowLeft
} from 'lucide-react';
import { handleFetchRequest } from '../../ApiHelper/ApiHelper';
import { useDispatch, useSelector } from 'react-redux';
import { getControls } from '../../redux/features/controls/controlSlice';
import { addEvidence, getEvidence } from '../../redux/features/evidence/evidenceSlice';
import ControlDetailView from './ControlDetailView';
import { mockControlsInitial } from '../../dummy/dummy';
import { addEvaluation } from '../../redux/features/evaluation/evaluationSlice';
import PageLoader from '../../Loder/PageLoader';
import { Spin, Layout } from 'antd';
const { Content } = Layout;

// --- FRAMEWORK SUMMARY CARD (NEW UI) ---
const FrameworkSummaryCard = ({ framework, onViewControls }) => {
    // Calculate stats based on controls array
    const controls = framework.controls || [];
    const totalControls = controls.length;
    const passingControls = controls.filter(c => ['Passed', 'Passing'].includes(c.status)).length;
    // Assuming 'Failing' or 'Open' represent issues for the dashboard
    const openIssues = controls.filter(c => ['Failing'].includes(c.status)).length;

    const progressPercent = totalControls === 0 ? 0 : Math.round((passingControls / totalControls) * 100);
    const status = progressPercent > 0 ? "Active" : "Draft";

    return (
        <>
            <div
                onClick={() => onViewControls(framework.frameworkId)}
                className="bg-white ring-1 ring-slate-200/60 rounded-3xl cursor-pointer shadow-sm overflow-hidden transition-all hover:shadow-xl hover:shadow-indigo-500/5 hover:-translate-y-1 hover:ring-indigo-200 flex flex-col hover:ring-indigo-300 transition-all group flex flex-col relative overflow-hidden">
                {/* Card Header & Content */}
                <div className="p-6 flex-1 flex flex-col">
                    <div className="flex justify-between items-start mb-4">
                        <h3 className="font-extrabold text-slate-900 text-xl tracking-tight">{framework.frameworkName}</h3>
                        <span className={`px-2.5 py-1 text-[10px] font-black uppercase tracking-widest rounded-md ring-1 shadow-sm shrink-0 ${status === 'Active' ? 'bg-emerald-50 text-emerald-700 ring-emerald-200' :
                            framework.status === 'Archived' ? 'bg-slate-100 text-slate-600 ring-slate-200' :
                                'bg-amber-50 text-amber-700 ring-amber-200'
                            }`}>
                            {status}
                        </span>
                    </div>

                    <p className="text-sm text-slate-500 font-medium leading-relaxed line-clamp-2 mb-6">
                        {framework.description || "Security compliance framework"}
                    </p>

                    {/* Progress Bar */}
                    <div className="mb-6">
                        <div className="flex justify-between items-end mb-2">
                            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Progress</span>
                            <span className="text-sm font-black text-slate-900">{progressPercent}%</span>
                        </div>
                        <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-indigo-500 to-blue-500 rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${progressPercent}%` }}
                            />
                        </div>
                    </div>

                    {/* Metrics Grid */}
                    <div className="grid grid-cols-2 gap-3 mb-6">
                        <div className="bg-slate-50 rounded-xl p-3 ring-1 ring-slate-200/60">
                            <div className="flex items-center gap-1.5 text-slate-500 mb-1">
                                <CheckCircle2 size={14} className="text-emerald-500" />
                                <span className="text-[10px] font-black uppercase tracking-wider">Controls</span>
                            </div>
                            <p className="text-sm font-bold text-slate-900">
                                {passingControls}/{totalControls} <span className="text-[15px] font-normal text-slate-500">Total</span>
                            </p>
                        </div>
                        <div className="bg-slate-50 rounded-xl p-3 ring-1 ring-slate-200/60">
                            <div className="flex items-center gap-1.5 text-slate-500 mb-1">
                                <AlertCircle size={14} className="text-rose-500" />
                                <span className="text-[10px] font-black uppercase tracking-wider">Issues</span>
                            </div>
                            <p className="text-sm font-bold text-slate-900">
                                {openIssues} <span className="text-[15px] font-normal text-slate-500">Open</span>
                            </p>
                        </div>
                    </div>

                    {/* Tags */}
                    {/* <div className="flex flex-wrap gap-2 mt-auto">
                        {framework.tags?.map((tag, idx) => (
                            <span key={idx} className="px-2.5 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-widest rounded-md ring-1 ring-slate-200/60">
                                {tag}
                            </span>
                        ))}
                    </div> */}
                    <div className="flex flex-wrap gap-2 ">
                        <span className="px-2.5 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-widest rounded-md ring-1 ring-slate-200/60">Standard</span>
                        <span className="px-2.5 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-widest rounded-md ring-1 ring-slate-200/60">Security</span>
                        <span className="px-2.5 py-1 bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-widest rounded-md ring-1 ring-slate-200/60">{status}</span>
                    </div>
                </div>

                {/* Card Footer Actions */}
                <div className="px-6 py-4 bg-slate-50/50 border-t border-slate-100 flex flex-wrap items-center justify-between gap-2 mt-auto">
                    <div className="flex flex-col">
                        <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">View Controls</span>
                    </div>
                    <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 group-hover:bg-indigo-600 group-hover:text-white transition-colors shadow-sm">
                        <ArrowRight size={16} strokeWidth={2.5} />
                    </div>
                </div>
            </div>
        </>
    );
};

// --- FRAMEWORK SECTION ---
const FrameworkGroup = ({ setPageIsLoading, pageIsLoading, framework, controls, currentUser, onAddEvidence, evidenceData, onEvidenceAction, onViewDetails, onStatusChange, setActiveFrameworkId }) => {
    // Calculate progress and counts
    const totalControls = controls?.length || 0;
    const passingControls = controls?.filter(c => ['Passed', 'Passing'].includes(c.status)).length || 0;
    const pendingControls = controls?.filter(c => ['Pending', 'Not Started', 'Draft'].includes(c.status)).length || 0;
    const inReviewControls = controls?.filter(c => ['In Review'].includes(c.status)).length || 0;

    const progressPercent = totalControls === 0 ? 0 : Math.round((passingControls / totalControls) * 100);
    const pendingPercent = totalControls === 0 ? 0 : Math.round((pendingControls / totalControls) * 100);
    const inReviewPercent = totalControls === 0 ? 0 : Math.round((inReviewControls / totalControls) * 100);

    return (
        <div className="mb-14 animate-in fade-in slide-in-from-bottom-4 duration-500">
            {/* High-End Framework Header */}
            <div className="flex flex-col xl:flex-row xl:items-end justify-between gap-6 mb-6 pb-5 border-b border-slate-200/70">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center  gap-4">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => setActiveFrameworkId(null)}
                            className="p-2.5 bg-white ring-1 ring-slate-200 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 hover:ring-indigo-200 rounded-xl transition-all shadow-sm"
                            title="Back"
                        >
                            <ArrowLeft size={20} strokeWidth={2.5} />
                        </button>
                        <div>
                            <h2 className="text-xl md:text-2xl font-black text-slate-900 tracking-tight flex items-center gap-3">{framework.frameworkName}</h2>
                            <div className="flex items-center gap-3 mt-1">
                                <p className="text-sm font-semibold text-slate-500">Framework Controls</p>
                                <span className="w-1.5 h-1.5 rounded-full bg-slate-300"></span>
                                <div className="flex items-center gap-1.5 text-sm font-bold text-slate-700">
                                    <LayoutGrid size={14} className="text-slate-400" />
                                    {totalControls} Total
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side: Metrics Panel (Count Based) */}
                <div className="w-full xl:w-auto flex flex-col sm:flex-row gap-4">
                    {/* Completion Count */}
                    <div className="flex-1 sm:w-48 bg-white p-3.5 rounded-2xl border border-slate-200/60 shadow-sm">
                        <div className="flex justify-between items-end mb-2">
                            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Completed</span>
                            <span className="text-sm font-black text-emerald-600">
                                {passingControls} <span className="text-slate-400 text-xs font-bold">/ {totalControls}</span>
                            </span>
                        </div>
                        <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${progressPercent}%` }}
                            />
                        </div>
                    </div>
                    
                    
                    {/* In Review Count */}
                    <div className="flex-1 sm:w-48 bg-white p-3.5 rounded-2xl border border-slate-200/60 shadow-sm">
                        <div className="flex justify-between items-end mb-2">
                            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">In-Review</span>
                            <span className="text-sm font-black text-amber-500">
                                {inReviewControls} <span className="text-slate-400 text-xs font-bold">/ {totalControls}</span>
                            </span>
                        </div>
                        <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-amber-400 to-amber-500 rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${inReviewPercent}%` }}
                            />
                        </div>
                    </div>

                    {/* Pending Count */}
                    <div className="flex-1 sm:w-48 bg-white p-3.5 rounded-2xl border border-slate-200/60 shadow-sm">
                        <div className="flex justify-between items-end mb-2">
                            <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Pending</span>
                            <span className="text-sm font-black text-amber-500">
                                {pendingControls} <span className="text-slate-400 text-xs font-bold">/ {totalControls}</span>
                            </span>
                        </div>
                        <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-amber-400 to-amber-500 rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${pendingPercent}%` }}
                            />
                        </div>
                    </div>

                </div>
            </div>

            {/* Controls Grid View */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {controls?.map((control, idx) => (
                    <div key={control.projectControlId} style={{ animationDelay: `${idx * 50}ms` }} className="animate-in fade-in zoom-in-95 fill-mode-both duration-300">
                        <ControlCard
                            setPageIsLoading={setPageIsLoading}
                            pageIsLoading={pageIsLoading}
                            control={control}
                            frameworkId={framework.frameworkId}
                            currentUser={currentUser}
                            onAddEvidence={onAddEvidence}
                            evidenceData={evidenceData?.[control?.projectControlId]}
                            onEvidenceAction={onEvidenceAction}
                            onViewDetails={onViewDetails}
                            onStatusChange={onStatusChange}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

// --- SINGLE CONTROL CARD ---
const ControlCard = ({ control, frameworkId, currentUser, onAddEvidence, evidenceData, onEvidenceAction, onViewDetails, onStatusChange }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Premium styling config based on status
    const statusConfig = {
        'Passed': { color: 'emerald', icon: <CheckCircle2 size={12} />, bg: 'bg-emerald-50 text-emerald-700 ring-emerald-200/50', dot: 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]' },
        'Passing': { color: 'emerald', icon: <CheckCircle2 size={12} />, bg: 'bg-emerald-50 text-emerald-700 ring-emerald-200/50', dot: 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]' },
        'Failing': { color: 'rose', icon: <AlertCircle size={12} />, bg: 'bg-rose-50 text-rose-700 ring-rose-200/50', dot: 'bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.5)]' },
        'In Review': { color: 'blue', icon: <Clock size={12} />, bg: 'bg-blue-50 text-blue-700 ring-blue-200/50', dot: 'bg-blue-500 shadow-[0_0_8px_rgba(59,130,246,0.5)]' },
        'Draft': { color: 'amber', icon: <FileText size={12} />, bg: 'bg-amber-50 text-amber-700 ring-amber-200/50', dot: 'bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.5)]' },
        'Pending': { color: 'slate', icon: <CircleDashed size={12} />, bg: 'bg-slate-50 text-slate-700 ring-slate-200/50', dot: 'bg-slate-400' },
        'Not Started': { color: 'slate', icon: <CircleDashed size={12} />, bg: 'bg-slate-50 text-slate-700 ring-slate-200/50', dot: 'bg-slate-400' },
        'Not Applicable': { color: 'slate', icon: <X size={12} />, bg: 'bg-slate-50 text-slate-500 ring-slate-200/30 opacity-70', dot: 'bg-slate-300' },
        'Excluded': { color: 'slate', icon: <X size={12} />, bg: 'bg-slate-50 text-slate-500 ring-slate-200/30 opacity-70', dot: 'bg-slate-300' }
    };

    const config = statusConfig[control.status] || statusConfig['Pending'];
    const displayStatus = control.status === "Not Started" ? "Pending" : control.status;

    const renderActions = () => {
        let button = null;
        let menuItems = [];
        const PrimaryBtn = ({ onClick, label, variant = 'solid' }) => (
            <button onClick={onClick} className={`w-full flex items-center justify-center gap-2 px-4 py-2 text-sm  rounded-lg transition-all group ${variant === 'solid'
                ? 'bg-indigo-600 text-white hover:bg-indigo-800 shadow-md shadow-slate-900/10 hover:shadow-lg hover:-translate-y-0.5'
                : 'bg-white text-slate-700 ring-1 ring-slate-200 hover:bg-slate-50 hover:ring-slate-300 shadow-sm'
                }`}>
                {label}
                <ArrowRight size={16} className={`transition-transform duration-300 ${variant === 'solid' ? 'text-slate-300 group-hover:translate-x-1' : 'text-slate-400 group-hover:translate-x-1'}`} />
            </button>
        );

        if (currentUser.role === 'Reviewer' && control.status === 'In Review') {
            button = <PrimaryBtn onClick={() => onViewDetails(control)} label="Review Evidence" />;
        } else {
            switch (control.status) {
                case 'Passed':
                case 'Passing':
                case 'In Review':
                    menuItems.push({ label: 'View Details', action: () => onViewDetails(control) });
                    button = <PrimaryBtn onClick={() => onViewDetails(control)} label="View Details" variant="outline" />;
                    break;
                case 'Failing':
                    if (currentUser.role !== 'Reviewer') {
                        button = <PrimaryBtn onClick={() => onAddEvidence(control)} label="Modify Evidence" variant="outline" />;
                    }
                    menuItems.push({ label: 'View Details', action: () => onViewDetails(control) });
                    break;
                case 'Pending':
                case 'Not Started':
                    if (currentUser.role !== 'Reviewer') {
                        button = <PrimaryBtn onClick={() => onAddEvidence(control)} label="Add Evidence" />;
                    }
                    menuItems.push({ label: 'Mark as Excluded', action: () => onStatusChange(control.projectControlId, frameworkId, 'Excluded') });
                    break;
                case 'Draft':
                    button = <PrimaryBtn onClick={() => onEvidenceAction(control.projectControlId, frameworkId, evidenceData, 'submit')} label="Submit For Review" />;
                    menuItems.push({ label: 'View Details', action: () => onViewDetails(control) });
                    menuItems.push({ label: 'Modify Draft', action: () => onAddEvidence(control) });
                    break;
                case 'Not Applicable':
                case 'Excluded':
                    button = <button disabled className="w-full px-4 py-2.5 text-sm font-bold text-slate-400 bg-slate-50 ring-1 ring-slate-200/50 rounded-xl cursor-not-allowed">Not Applicable</button>;
                    break;
                default:
                    break;
            }
        }

        const modifyStatusMenu = (
            <>
                {control.status === 'Not Applicable' && <>
                    <a href="#" onClick={(e) => { e.preventDefault(); onStatusChange(control.projectControlId, frameworkId, 'Pending'); setIsMenuOpen(false); }} className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 font-semibold transition-colors">Change to: Pending</a>
                    <a href="#" onClick={(e) => { e.preventDefault(); onStatusChange(control.projectControlId, frameworkId, 'Excluded'); setIsMenuOpen(false); }} className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 font-semibold transition-colors">Change to: Excluded</a>
                </>}
                {control.status === 'Excluded' && <>
                    <a href="#" onClick={(e) => { e.preventDefault(); onStatusChange(control.projectControlId, frameworkId, 'Pending'); setIsMenuOpen(false); }} className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 font-semibold transition-colors">Change to: Pending</a>
                    <a href="#" onClick={(e) => { e.preventDefault(); onStatusChange(control.projectControlId, frameworkId, 'Not Applicable'); setIsMenuOpen(false); }} className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 font-semibold transition-colors">Change to: Not Applicable</a>
                </>}
            </>
        );

        return (
            <div className="flex items-center gap-3 mt-auto pt-5 border-t border-slate-100">
                <div className="flex-1">
                    {button}
                </div>

                {/* Modern 3-Dot Dropdown */}
                <div className="relative shrink-0">
                    <button onClick={(e) => { e.stopPropagation(); setIsMenuOpen(!isMenuOpen); }} onBlur={() => setTimeout(() => setIsMenuOpen(false), 200)} className="p-2.5 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-all ring-1 ring-transparent hover:ring-slate-200/60">
                        <MoreVertical className="w-5 h-5" />
                    </button>
                    {isMenuOpen && (
                        <div className="absolute right-0 bottom-full mb-2 w-48 bg-white/80 backdrop-blur-xl rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] z-50 ring-1 ring-slate-200/60 py-2 overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200">
                            {control.status === 'Not Applicable' || control.status === 'Excluded'
                                ? modifyStatusMenu
                                : menuItems?.map(item => (
                                    <a href="#" key={item.label} onClick={(e) => { e.preventDefault(); item.action(); setIsMenuOpen(false); }} className="block px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition-colors">{item.label}</a>
                                ))
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="relative bg-white rounded-3xl ring-1 ring-slate-200/60 shadow-sm hover:shadow-xl hover:shadow-indigo-500/5 hover:-translate-y-1 hover:ring-indigo-200 transition-all duration-300 flex flex-col h-full overflow-hidden">
            <div className="p-6 flex flex-col flex-1">
                {/* Header Row: Ref Code + Status Pill */}
                <div className="flex justify-between items-start mb-4">
                    {control?.referenceCode ? (
                        <span className="bg-slate-100 text-slate-600 px-2.5 py-1 rounded-lg text-xs font-black tracking-widest uppercase shadow-sm">
                            {control.referenceCode}
                        </span>
                    ) : <div />} {/* Empty div to keep flex space-between intact */}

                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-[11px] font-black uppercase tracking-wider ring-1 shadow-sm ${config.bg}`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
                        {displayStatus}
                    </span>
                </div>

                <h5 className="font-extrabold text-slate-900 text-lg leading-snug mb-2">
                    {control.controlName}
                </h5>

                <p className="text-sm text-slate-500 font-medium leading-relaxed line-clamp-3 mb-6">
                    {control.description}
                </p>

                {renderActions()}
            </div>
        </div>
    );
};

// --- MODERN EVIDENCE MODAL ---
const EvidenceModal = ({ setPageIsLoading, pageIsLoading, activeFrameworkId, isOpen, createEvaluations, onClose, onAction, control, existingEvidence, handleFetchRequest }) => {
    const [narrative, setNarrative] = useState('');
    const [files, setFiles] = useState([]);
    const [selectedPolicies, setSelectedPolicies] = useState([]); // NEW: State for linked policies
    const [isDragging, setIsDragging] = useState(false);
    const dispatch = useDispatch();

    console.log("##control", control);

    // Mock policy library data (In a real app, this might come from props or an API fetch)
    const availablePolicies = [
        { id: 'pol_1', name: 'Access Control Policy', version: '1.2' },
        { id: 'pol_2', name: 'Password Policy', version: '1.1' },
        { id: 'pol_3', name: 'Incident Response Policy', version: '2.0' },
        { id: 'pol_4', name: 'Data Protection Policy', version: '1.0' },
    ];

    useEffect(() => {
        if (!isOpen) {
            setNarrative('');
            setFiles([]);
            setSelectedPolicies([]);
            return;
        }
        if (existingEvidence) {
            setNarrative(existingEvidence.narrative || '');
            setFiles(existingEvidence.files || []);
            setSelectedPolicies(existingEvidence.policies || []);
        }
    }, [existingEvidence, isOpen]);

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        const totalFiles = files.length + newFiles.length;

        if (totalFiles > 10) {
            alert('Maximum 10 files can be uploaded.');
            return;
        }
        setFiles(prev => [...prev, ...newFiles.map(f => ({ name: f.name, file: f }))]);
    };

    const removeFile = (indexToRemove) => {
        setFiles(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // NEW: Handle attaching a policy
    const handlePolicySelect = (e) => {
        const policyId = e.target.value;
        if (!policyId) return;

        const policyToAdd = availablePolicies.find(p => p.id === policyId);

        // Prevent duplicates
        if (policyToAdd && !selectedPolicies.some(p => p.id === policyId)) {
            setSelectedPolicies(prev => [...prev, policyToAdd]);
        }

        e.target.value = ""; // Reset dropdown
    };

    const removePolicy = (policyId) => {
        setSelectedPolicies(prev => prev.filter(p => p.id !== policyId));
    };

    const handleAction = async (submissionType) => {
        if (!narrative.trim() || (files.length === 0 && selectedPolicies.length === 0)) return;
        try {
         
            setPageIsLoading(true);
            if (submissionType === 'submit') {
                const formData = new FormData();
                formData.append('projectControlId', control?.projectControlId);
                formData.append('narrative', narrative);

                // Append custom files
                files.forEach((fileObj) => {
                    if (fileObj.file) formData.append('files[]', fileObj.file);
                });

                // Append linked policy IDs
                selectedPolicies.forEach(policy => {
                    formData.append('policyIds[]', policy.id);
                });

                const result = await dispatch(addEvidence(formData)).unwrap();
                if(result?.status) {
                    console.log("##handleAction", result);
                    createEvaluations(result?.data);
                    // activeFrameworkId
                    // control.frameworkId || control?.projectControlId
                    onAction(control?.id || control?.controlId, activeFrameworkId , { narrative, files, policies: selectedPolicies }, submissionType);
                    onClose();
                }
                // handleFetchRequest("evidence", apiUrl.add_evidence, "POST", formData, null, true).then((response) => {
                //     if (response?.status === true) {
                //         setPageIsLoading(false);
                //         createEvaluations(response?.data);
                //         onAction(control.id, control.frameworkId, { narrative, files, policies: selectedPolicies }, submissionType);
                //         onClose();
                //     } else {
                //         setPageIsLoading(false);
                //     }
                // });
            } else {
                onAction(control.id, control.frameworkId, { narrative, files, policies: selectedPolicies }, submissionType);
            }
           
        } catch (error) {
            console.log('##error', error);
        } finally {            
            setPageIsLoading(false);
        }
    };

    if (!isOpen || !control) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
            <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="bg-white rounded-[2rem] shadow-2xl w-full max-w-2xl relative z-10 flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <div className="px-8 py-6 border-b border-slate-100 bg-white flex justify-between items-start">
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <span className="bg-indigo-50 text-indigo-600 px-2.5 py-1 rounded-lg text-xs font-black tracking-widest uppercase shadow-sm ring-1 ring-indigo-100">
                                {control.referenceCode ?? 'Upload'}
                            </span>
                        </div>
                        <h2 className="text-2xl font-black text-slate-900 tracking-tight">{control?.controlName || 'Add Evidence'}</h2>
                    </div>
                    <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded-full transition-colors">
                        <X size={20} strokeWidth={2.5} />
                    </button>
                </div>

                <div className="p-8 space-y-8 overflow-y-auto max-h-[60vh] bg-slate-50/50">
                    <div>
                        <label htmlFor="narrative" className="block text-sm font-black text-slate-700 mb-2 tracking-wide">Narrative / Justification</label>
                        <textarea
                            id="narrative"
                            value={narrative}
                            onChange={(e) => setNarrative(e.target.value)}
                            rows="4"
                            className="w-full px-5 py-4 bg-white ring-1 ring-slate-200 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/50 focus:border-indigo-500 transition-all text-sm font-medium resize-none placeholder-slate-400"
                            placeholder="Detail how your organization meets the requirements for this control..."
                        />
                    </div>

                    <div className="border-t border-slate-200/60 pt-6 space-y-6">
                        <div className="flex items-center justify-between">
                            <h3 className="text-base font-black text-slate-800 tracking-tight">Evidence Attachments</h3>
                            <span className="text-xs font-bold text-slate-400 bg-slate-100 px-2 py-1 rounded-lg">
                                {files.length + selectedPolicies.length} Total Attached
                            </span>
                        </div>

                        {/* --- NEW: SELECT FROM POLICIES SECTION --- */}
                        <div className="bg-white p-5 rounded-3xl ring-1 ring-slate-200 shadow-sm">
                            <label className="block text-xs font-black text-slate-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                                <FileBadge size={16} className="text-indigo-500" /> Select From Policies
                            </label>

                            <select
                                onChange={handlePolicySelect}
                                className="w-full px-4 py-3.5 bg-slate-50 ring-1 ring-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all text-sm font-semibold text-slate-700 cursor-pointer appearance-none mb-4"
                            >
                                <option value="">+ Choose a policy from the library...</option>
                                {availablePolicies.map(policy => (
                                    <option key={policy.id} value={policy.id}>
                                        {policy.name} (v{policy.version})
                                    </option>
                                ))}
                            </select>

                            {selectedPolicies.length > 0 && (
                                <ul className="space-y-2 mt-2">
                                    {selectedPolicies.map((policy) => (
                                        <li key={policy.id} className="flex items-center justify-between text-sm font-bold text-slate-700 p-2.5 rounded-xl bg-indigo-50/50 ring-1 ring-indigo-100 group">
                                            <div className="flex items-center truncate pr-4">
                                                <div className="p-2 bg-indigo-100 text-indigo-700 rounded-lg mr-3">
                                                    <FileBadge className="w-4 h-4" />
                                                </div>
                                                <span className="truncate">{policy.name} <span className="text-xs text-indigo-400 ml-1">v{policy.version}</span></span>
                                            </div>
                                            <button type="button" onClick={() => removePolicy(policy.id)} className="p-2 text-indigo-300 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors">
                                                <X className="w-4 h-4" />
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="relative flex items-center py-2">
                            <div className="flex-grow border-t border-slate-200"></div>
                            <span className="flex-shrink-0 mx-4 text-xs font-bold text-slate-400 uppercase tracking-widest">OR</span>
                            <div className="flex-grow border-t border-slate-200"></div>
                        </div>

                        {/* --- EXISTING: UPLOAD CUSTOM DOCUMENT SECTION --- */}
                        <div className="bg-white p-5 rounded-3xl ring-1 ring-slate-200 shadow-sm">
                            <label className="block text-xs font-black text-slate-500 uppercase tracking-widest mb-3 flex items-center gap-2">
                                <UploadCloud size={16} className="text-slate-400" /> Upload Document
                            </label>

                            <div
                                className={`relative flex justify-center px-6 py-8 border-2 border-dashed rounded-2xl transition-all duration-300 ${isDragging ? 'border-indigo-500 bg-indigo-50/50 shadow-inner' : 'border-slate-300 bg-slate-50 hover:bg-slate-100 hover:border-indigo-300'}`}
                                onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                                onDragLeave={() => setIsDragging(false)}
                                onDrop={(e) => { e.preventDefault(); setIsDragging(false); }}
                            >
                                <div className="space-y-2 text-center relative z-10">
                                    <div className="text-sm font-bold text-slate-700">
                                        <label htmlFor="file-upload" className="relative cursor-pointer text-indigo-600 hover:text-indigo-700 hover:underline decoration-indigo-300 underline-offset-4 transition-all">
                                            <span>Click to browse</span>
                                            <input id="file-upload" name="files[]" type="file" className="sr-only" multiple onChange={handleFileChange} disabled={files.length >= 10} />
                                        </label>
                                        <span className="text-slate-500 font-medium"> or drag and drop</span>
                                    </div>
                                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">PDF, DOCX, PNG, JPG (Max 10MB)</p>
                                </div>
                            </div>

                            {files.length > 0 && (
                                <ul className="space-y-2 mt-4">
                                    {files?.map((file, index) => (
                                        <li key={index} className="flex items-center justify-between text-sm font-bold text-slate-700 p-2.5 rounded-xl bg-slate-50 ring-1 ring-slate-200 group">
                                            <div className="flex items-center truncate pr-4">
                                                <div className="p-2 bg-white text-slate-500 rounded-lg mr-3 ring-1 ring-slate-200">
                                                    <FileText className="w-4 h-4" />
                                                </div>
                                                <span className="truncate">{file.name}</span>
                                            </div>
                                            <button type="button" onClick={() => removeFile(index)} className="p-2 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors">
                                                <X className="w-4 h-4" />
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>

                <div className="p-6 bg-white border-t border-slate-100 flex flex-col sm:flex-row justify-end items-center gap-3 rounded-b-[2rem]">
                    <button type="button" onClick={onClose} className="w-full sm:w-auto px-6 py-3 text-sm font-bold text-slate-600 bg-white ring-1 ring-slate-200 rounded-xl hover:bg-slate-50 transition-colors shadow-sm">
                        Cancel
                    </button>
                    <button type="button" onClick={() => handleAction('save')} className="w-full sm:w-auto px-6 py-3 text-sm font-bold text-indigo-700 bg-indigo-50 ring-1 ring-indigo-200/50 rounded-xl hover:bg-indigo-100 transition-colors">
                        Save Draft
                    </button>
                    <button type="button" onClick={() => handleAction('submit')} disabled={!narrative.trim() || (files.length === 0 && selectedPolicies.length === 0)} className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 text-sm font-bold text-white bg-indigo-600 rounded-xl shadow-md hover:bg-indigo-800 hover:-translate-y-0.5 transition-all group disabled:opacity-50 disabled:hover:translate-y-0 disabled:cursor-not-allowed">
                        <Check size={16} className={(!narrative.trim() || (files.length === 0 && selectedPolicies.length === 0)) ? "text-slate-300" : "text-emerald-400"} />
                        Submit For Review
                    </button>
                </div>
            </div>
        </div>
    );
};

// --- MAIN WRAPPER COMPONENT ---
const ControlsView = () => {
    const [pageIsLoading, setPageIsLoading] = useState(false);
    const [isEvidenceModalOpen, setIsEvidenceModalOpen] = useState(false);
    const [controls, setControls] = useState([]);
    const [selectedControl, setSelectedControl] = useState(null);    
    const [project, setProject] = useState(null);    
    const [projectId, setProjectId] = useState(localStorage.getItem("selectedProject"));
    const [evidenceData, setEvidenceData] = useState(null);

    const [evidenceDetails, setEvidenceDetails] = useState(null);
    const [remarksData, setRemarksData] = useState({});    
    const [previewingFile, setPreviewingFile] = useState(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);    
    const [mockControls, setMockControls] = useState(mockControlsInitial);

    const [view, setView] = useState(null);

    const dispatch = useDispatch();
    const { switched } = useSelector((state => state?.rootReducer?.project || {}));
    const { currentUser } = useSelector((state => state?.rootReducer?.users || {}));

    useEffect(() => {
        if(!switched?.projectId) return;
        setProjectId(switched?.projectId);  
        setProject(switched);
    }, [switched]);

    const onViewDetails = (control) => {
        setView({ type: 'controlDetail', data: control });
        getEvidenceDetails(control)
    };

    const getEvidenceDetails = async (control) => {
        setPageIsLoading(true);
        try {
            const result = await dispatch(getEvidence(control?.projectControlId)).unwrap();
            if(result?.status) {
                setEvidenceDetails(result?.data?.[0]);
            }
        } catch (error) {
            console.log("##error", error);   
        } finally {
            setView({ type: 'controlDetail', data: control });
            setPageIsLoading(false);
        }
    }

    // NEW STATE: Tracks which framework is currently being viewed in detail
    const [activeFrameworkId, setActiveFrameworkId] = useState(null);

    const handleOpenEvidenceModal = (control) => {
        setSelectedControl(control);
        setIsEvidenceModalOpen(true);
    };

    const handleEvidenceAction = (controlId, frameworkId, evidencePayload, submissionType) => {

        console.log("##activeFrameworkId", activeFrameworkId);
        console.log("##handleEvidenceAction", {controlId, frameworkId, evidencePayload, submissionType});
        const newStatus = submissionType === 'submit' ? 'In Review' : 'Draft';
        onStatusChange(controlId, frameworkId, newStatus);
        setEvidenceData(prev => ({
            ...prev,
            [controlId]: { ...evidencePayload }
        }));
        setIsEvidenceModalOpen(false);
        setSelectedControl(null);
    };

    const getControlsAndFrameworks = async () => {
        setPageIsLoading(true);
        try {
            const result = await dispatch(getControls(projectId)).unwrap();
            if(result?.status) {
                console.log('##getControlsAndFrameworks', result);
                setControls(result?.data);
            }            
        } catch (error) {
            console.log('##error', error);
        } finally {
            setPageIsLoading(false);
        }
    }

    const createEvaluations = async (data) => {
        setPageIsLoading(true);
        try {
            const lang = localStorage.getItem('languages') ?? 'English';
            const modifiedData = {
                ...data,
                languages: lang.split(",")
            }

            const result = await dispatch(addEvaluation(modifiedData)).unwrap();
            if(result && (result?.length > 0 || result?.[0])) {
                console.log("##createEvaluations", result?.status);
                getControlsAndFrameworks();
            }
                
        } catch (error) {
            console.log('##error', error);
        } finally {
            setPageIsLoading(false);
        }
        
        // handleFetchRequest("evaluation", apiUrl.add_evaluations, "POST", modifiedData).then((response) => {
        //     if (response?.status === true) {
        //         getControlsAndFrameworks();
        //     } else {
        //         setPageIsLoading(false);
        //         getControlsAndFrameworks();
        //     }
        // });
    }

    useEffect(() => {
        if(!projectId) return;
        getControlsAndFrameworks();
    }, [projectId, dispatch]);
    
    const onStatusChange = (controlId, frameworkId, newStatus) => {

        console.log("##onStatusChage", controlId, frameworkId, newStatus);
        setMockControls(prev => ({
            ...prev,
            [frameworkId]: prev[frameworkId]?.map(c => c.id === controlId ? { ...c, status: newStatus } : c)
        }));
    };

    const handlePreviewFile = (file) => {
        setPreviewingFile(file);
        setIsPreviewModalOpen(true);
    };

    const handleAddRemark = (controlId, remarkText) => {
        const newRemark = {
            text: remarkText,
            reviewerName: currentUser.name,
            date: new Date().toISOString()
        };
        setRemarksData(prev => ({
            ...prev,
            [controlId]: [...(prev[controlId] || []), newRemark]
        }));
    };

    // Request Changes Modal
    const RequestChangesModal = ({ isOpen, onClose, onSubmit }) => {
        const [remark, setRemark] = useState('');
    
        const handleSubmit = (e) => {
            e.preventDefault();
            if (!remark) return;
            onSubmit(remark);
            setRemark('');
            onClose();
        };
    
        if (!isOpen) return null;
    
        return (
            <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg m-4 animate-in zoom-in-95 duration-200" onClick={(e) => e.stopPropagation()}>
                    <form onSubmit={handleSubmit}>
                        <div className="p-6 border-b border-slate-100 bg-slate-50 rounded-t-2xl">
                            <h2 className="text-xl font-extrabold text-slate-900">Request Changes</h2>
                            <p className="text-sm font-medium text-slate-500 mt-1">Provide feedback for the user to address.</p>
                        </div>
                        <div className="p-6">
                            <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wider">Feedback Details</label>
                            <textarea value={remark} onChange={(e) => setRemark(e.target.value)} rows="5" className="w-full px-4 py-3 border border-slate-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm transition-shadow" placeholder="e.g., Please provide the access review logs for Q3..."></textarea>
                        </div>
                        <div className="p-6 bg-slate-50 border-t border-slate-100 flex justify-end space-x-3 rounded-b-2xl">
                            <button type="button" onClick={onClose} className="px-5 py-2.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-lg shadow-sm hover:bg-slate-50 transition-colors">Cancel</button>
                            <button type="submit" className="px-5 py-2.5 text-sm font-bold text-white bg-amber-500 border border-transparent rounded-lg shadow-sm hover:bg-amber-600 transition-colors active:scale-95">Submit Feedback</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };

      // 1. Initialize the ref for the scrolling container
  const mainRef2 = useRef(null); 
  useEffect(() => {
    if (mainRef2.current) {
      mainRef2.current.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto"
      });
    }
  }, [view?.type]);
  // ==========================================

    return (
         <main ref={mainRef2} className={`flex-1 overflow-x-hidden overflow-y-auto h-100 p-4 sm:p-6 lg:p-8}`}>
            <Content className="main-body" id="scrolly-div">
                <Spin spinning={pageIsLoading} size="large">
                    { view?.type === 'controlDetail' ? (
                        <ControlDetailView
                            mockControlsInitial={mockControlsInitial}
                            // handleFetchRequest={handleFetchRequest}
                            RequestChangesModal={RequestChangesModal}
                            setPageIsLoading={setPageIsLoading}
                            pageIsLoading={pageIsLoading}
                            control={view.data}
                            evidence={evidenceDetails}
                            remarks={remarksData[view.data.id]}
                            onBack={() => setView({ type: 'controls', data: null })}
                            onPreviewFile={handlePreviewFile}
                            currentUser={currentUser}
                            onStatusChange={(...args) => onStatusChange(view.data.id, ...args)}
                            onAddRemark={(...args) => handleAddRemark(view.data.id, ...args)}
                            isPreviewModalOpen={isPreviewModalOpen}
                            setIsPreviewModalOpen={() => setIsPreviewModalOpen(false)}
                            file={previewingFile}
                        />
                    ): (<>
                        <div className=" bg-slate-50 relative">
                            <div className="max-w-[1600px] mx-auto">
                                {!activeFrameworkId && <div className="mb-8 flex items-center gap-3">
                                    <div className="p-3 bg-indigo-600 rounded-2xl shadow-lg shadow-indigo-600/20 text-white">
                                        <ShieldCheck size={28} strokeWidth={2} />
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-black text-slate-900 tracking-tight">Compliance Controls</h3>
                                        <p className="text-sm font-semibold text-slate-500 mt-0.5">Monitor framework health and manage evidence.</p>
                                    </div>
                                </div>}

                                {/* CONDITIONAL RENDERING: Card View vs Detail View */}
                                {activeFrameworkId ? (
                                    <div className="animate-in fade-in slide-in-from-right-4 duration-300">
                                        {(controls || [])
                                            .filter(item => item.frameworkId === activeFrameworkId)
                                            .map((item, index) => (
                                                <FrameworkGroup
                                                    setPageIsLoading={setPageIsLoading}
                                                    pageIsLoading={pageIsLoading}
                                                    key={index}
                                                    framework={item}
                                                    controls={item.controls}
                                                    currentUser={currentUser}
                                                    onAddEvidence={handleOpenEvidenceModal}
                                                    evidenceData={evidenceData}
                                                    onEvidenceAction={handleEvidenceAction}
                                                    onViewDetails={onViewDetails}
                                                    onStatusChange={onStatusChange}
                                                    setActiveFrameworkId={setActiveFrameworkId}
                                                />
                                            ))}
                                    </div>
                                ) : (
                                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 animate-in fade-in zoom-in-95 duration-300">
                                        {(controls || [])?.map((item, index) => (
                                            <FrameworkSummaryCard
                                                key={index}
                                                framework={item}
                                                onViewControls={(id) => setActiveFrameworkId(id)}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>

                            <EvidenceModal
                                setPageIsLoading={setPageIsLoading}
                                pageIsLoading={pageIsLoading}
                                isOpen={isEvidenceModalOpen}
                                createEvaluations={createEvaluations}
                                onClose={() => {
                                    console.log("##EvidenceModal", 'closed');
                                    setIsEvidenceModalOpen(false);
                                }}
                                onAction={handleEvidenceAction}
                                activeFrameworkId={activeFrameworkId}
                                
                                // handleFetchRequest={handleFetchRequest}
                                control={selectedControl}
                                existingEvidence={selectedControl ? evidenceData?.[selectedControl.controlId] : null}
                                // existingEvidence={selectedControl ? evidenceData?.[selectedControl.id] : null}
                            />            
                        </div>
                    </>)}
                </Spin>
            </Content>
        </main>
    );
};

export default ControlsView;